/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import { ScreenRedirect } from '@jira/platform__routing-screen-redirect/src/ui/ScreenRedirect.tsx';
import { useRouter } from '@atlassian/react-resource-router';

const RedirectLegacyReportPage = (): React.JSX.Element => {
	const [{ query }] = useRouter();

	return <ScreenRedirect to={`/jira/plans/reports/${query.r}`} persistSearchParams={false} />;
};

export default RedirectLegacyReportPage;
